(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-animated"] && !Shopify.designMode) return;
  try {
    class AnimatedProductCard {
    constructor(element) {
      this.card = element;
      this.addButton = this.card.querySelector('.tf-product-card__add-btn');
      this.dialogId = this.card.dataset.dialogId;
      this.dialog = this.dialogId ? document.getElementById(this.dialogId) : null;
      this.detailsButton = this.card.querySelector('.tf-product-card__details-btn');

      if (this.addButton) {
        this.productId = this.addButton.dataset.productId;
        this.variantId = this.addButton.dataset.variantId;
      }

      this.init();
    }

    init() {
      if (this.addButton) {
        this.addButton.addEventListener('click', this.handleAddToCart.bind(this));
      }

      if (this.dialog) {
        this.card.addEventListener('click', (event) => this.handleCardClick(event));
        if (this.detailsButton) {
          this.detailsButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.openDialog();
          });
        }

        const closeButton = this.dialog.querySelector('[data-dialog-close]');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.closeDialog());
        }

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.closeDialog();
          }
        });
      }
    }

    handleCardClick(event) {
      if (!this.dialog) return;
      if (event.target.closest('button, a, input, select, textarea')) return;
      this.openDialog();
    }

    openDialog() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
    }

    closeDialog() {
      if (!this.dialog || !this.dialog.open) return;
      this.dialog.close();
    }

    async handleAddToCart(e) {
      if (!this.addButton) return;
      e.preventDefault();
      e.stopPropagation();

      if (this.addButton.disabled || this.addButton.classList.contains('is-loading')) {
        return;
      }

      this.setLoading(true);

      try {
        const formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1
            }
          ]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();

        // Dispatch custom event for cart drawer or other listeners
        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: { items: data.items, cart: data }
          })
        );

        // Update cart count if element exists
        this.updateCartCount();

        // Show success feedback
        this.showSuccessFeedback();

      } catch (error) {
        console.error('Add to cart error:', error);
        this.showErrorFeedback();
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      if (isLoading) {
        this.addButton.classList.add('is-loading');
        this.originalText = this.addButton.textContent;
      } else {
        this.addButton.classList.remove('is-loading');
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });

        // Trigger cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(cart);
        }
      } catch (error) {
        console.error('Failed to update cart count:', error);
      }
    }

    showSuccessFeedback() {
      const originalText = this.addButton.textContent;
      this.addButton.textContent = 'Added!';
      this.addButton.style.backgroundColor = '#22c55e';

      setTimeout(() => {
        this.addButton.textContent = this.originalText;
        this.addButton.style.backgroundColor = '';
      }, 2000);
    }

    showErrorFeedback() {
      const originalText = this.addButton.textContent;
      this.addButton.textContent = 'Error';
      this.addButton.style.backgroundColor = '#ef4444';

      setTimeout(() => {
        this.addButton.textContent = this.originalText;
        this.addButton.style.backgroundColor = '';
      }, 2000);
    }
  }

  // Initialize all product cards
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tf-product-card').forEach(card => {
      new AnimatedProductCard(card);
    });
  });

  // Reinitialize on Shopify theme editor updates
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.tf-product-card').forEach(card => {
        new AnimatedProductCard(card);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
